import { Signal, createRoot, createSignal } from 'solid-js'
import type { ArmyPaintCollection } from '../../../lib/core/ArmyPainter/ArmyPaintCollection.type'
import { isPlainObjDeeplyEqual } from '../../../lib/isPlainObjDeeplyEqual'
import ls from '../../../lib/localStorage'
import createEmptyArmyPaintCollection from './createEmptyArmyPaintCollection'
import getArmyPaintCollectionValueFromLocalStorage, { ARMY_PAINT_VALUE_LS_KEY } from './getArmyPaintCollectionValueFromLocalStorage'

const signal: Signal<ArmyPaintCollection> = createRoot(() => {
  const initialValue = getArmyPaintCollectionValueFromLocalStorage() || createEmptyArmyPaintCollection()

  // console.log('initialValue', deepClone(initialValue))

  const [getter, setter] = createSignal<ArmyPaintCollection>(initialValue, {
    equals: isPlainObjDeeplyEqual,
  })

  const update : typeof setter = (newValue: Parameters<typeof setter>[0]) => {
    setter(newValue)
    ls.setItem(ARMY_PAINT_VALUE_LS_KEY, JSON.stringify(getter()))
  }

  return [getter, update]
})

export const [getAuthArmyPaintCollection, setAuthArmyPaintCollection] = signal
